import React from 'react';
import PropTypes from 'prop-types';
import { CHAT_CONSTANTS } from '../../../utils';
import { getMediaTag } from '../../../utils/chatUtils';

function ChatMessages(props) {
  const { messages } = props;
  return messages && messages.map((el) => (
    <div className="message-detail-window-quote" key={Math.random()}>
      <div
        key={Math.random()}
        className={`message-detail-window-quote-row ${el.receiptType === CHAT_CONSTANTS.SENT_MESSAGE ? 'quote-push' : 'quote-pull'}`}
      >
        { el.receiptType === CHAT_CONSTANTS.RECEIVED_MESSAGE && <span className="time-col">{`BYGmusic admin, ${el.time}`}</span> }
        { el.receiptType === CHAT_CONSTANTS.SENT_MESSAGE && <span className="time-col">{el.time}</span> }
        {el.message.map((msg) => {
          if (msg && msg.message && msg.message.indexOf('http') > -1) {
            return (
              <div className="send-media-after-wrap" key={Math.random()}>
                {getMediaTag(msg)}
              </div>
            );
          }
          return (
            <p className="text-after-media" key={Math.random()}>
              {msg.message}
              {' '}
            </p>
          );
        })}
      </div>
    </div>
  ));
}

ChatMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    receiptType: PropTypes.string,
    message: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.string,
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
    })),
  })).isRequired,
};

export default React.memo(ChatMessages);
